import {useTranslation} from 'react-i18next';
import * as css from './TransactionDealSummary.css';
import {TEticketTransaction} from '../../../../redux/eTicket/eTicket.type';

interface TransactionDealSummaryProps {
    transaction: TEticketTransaction;
}

type Row = {key: string; label: string; value: string; discount?: boolean};

function TransactionDealSummary({transaction}: TransactionDealSummaryProps) {
    const {t} = useTranslation('eTicket');
    const {price, discount, couponDiscount, itemsCount} = transaction;
    const discountValue = discount && (discount.trim().startsWith('-') ? discount : `-${discount}`);
    const rows = [
        {key: 'price', label: t('dealPrice'), value: price},
        discountValue && {key: 'discount', label: t('discount'), value: discountValue, discount: true},
        couponDiscount && {key: 'coupon', label: t('coupon'), value: couponDiscount},
        itemsCount !== undefined && {key: 'items', label: t('itemsCount'), value: String(itemsCount)}
    ].filter(Boolean) as Row[];

    return (
        <css.kvList data-cy="transaction-deal-summary">
            {rows.map(row => (
                <css.kvRow key={row.key}>
                    <css.kvLabel>{row.label}</css.kvLabel>
                    <css.kvValue className={row.discount ? 'discount' : ''} dir="ltr">{row.value}</css.kvValue>
                </css.kvRow>
            ))}
        </css.kvList>
    );
}

export default TransactionDealSummary;
